import React, { useState, useMemo, useEffect } from 'react';
import './Table.css';

const Table = () => {
  const initialData = [
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L1', empresa: 'BAF', id: 'BV1_L1_T1_CC78', piezas: 2186, pesoKs: 89.2, corral: 'CC78' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L2', empresa: 'SER', id: 'BV1_L2_T1_Servax', piezas: 7396, pesoKs: 62, corral: 'Servax' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L2', empresa: 'SER', id: 'BV1_L2_T2_Servax', piezas: 1777, pesoKs: 64.1, corral: 'Servax' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L3', empresa: 'BAF', id: 'BV1_L3_T1_CC38', piezas: 5438, pesoKs: 49.7, corral: 'CC38' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L3', empresa: 'BAF', id: 'BVI_L3_T2_CC45', piezas: 6521, pesoKs: 52.7, corral: 'CC45' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L5', empresa: 'BAF', id: 'BV2_L5_T1_CC64', piezas: 612, pesoKs: 84.6, corral: 'CC64' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L5', empresa: 'BAF', id: 'BV1_L5_T1_CC65', piezas: 2835, pesoKs: 75.5, corral: 'CC65' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L5', empresa: 'BAF', id: 'BV1_L5_T2_CC64', piezas: 719, pesoKs: 74.5, corral: 'CC64' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L6', empresa: 'BAF', id: 'BV2_L6_T1_CC81', piezas: 942, pesoKs: 56.4, corral: 'CC81' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L6', empresa: 'BAF', id: 'BVI_L6_T1_CC43', piezas: 2186, pesoKs: 60.6, corral: 'CC43' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L6', empresa: 'SER', id: 'BV1_L6_T2_SERVAX', piezas: 5657, pesoKs: 63.1, corral: 'SERVAX' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L6', empresa: 'BAF', id: 'BVI_L6_T3_CC81', piezas: 1234, pesoKs: 61.2, corral: 'CC81' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L7', empresa: 'BAF', id: 'BV2_L7_T1_CC82', piezas: 2719, pesoKs: 65.8, corral: 'CC82' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L7', empresa: 'BAF', id: 'BV2_L7_T2_CC79', piezas: 3829, pesoKs: 60.9, corral: 'CC79' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L7', empresa: 'SER', id: 'BVI_L7_T1_Servax', piezas: 2965, pesoKs: 72.3, corral: 'SERVAX' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L8', empresa: 'BAF', id: 'BV2_L8_T1_CC81', piezas: 2006, pesoKs: 80, corral: 'CC81' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L8', empresa: 'BAF', id: 'BV2_L8_T2_CC47', piezas: 2938, pesoKs: 79, corral: 'CC47' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 2', lance: 'L8', empresa: 'BAF', id: 'BV2_L8_T3_CC31', piezas: 1231, pesoKs: 80.7, corral: 'CC31' },
    { bloque: 'BLOQUE #1', barco: 'Buenaventura 1', lance: 'L', empresa: 'BAF', id: 'BV1_L9_T1_CC80', piezas: 365, pesoKs: 74.7, corral: 'CC80' },
    { bloque: 'BLOQUE #2', barco: 'Buenaventura 2', lance: 'L', empresa: 'BAF', id: 'BV2_L1_T1_CC79_C1', piezas: 2362, pesoKs: 57.1, corral: 'CC79' },
    { bloque: 'BLOQUE #2', barco: 'Buenaventura 1', lance: 'L', empresa: 'BAF', id: 'BV1_L1_T1_CC80_C1', piezas: 5906, pesoKs: 54.3, corral: 'CC80' },


  ];

  const [filters, setFilters] = useState({});
  const [globalSearch, setGlobalSearch] = useState('');
  const [sortConfig, setSortConfig] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [mobileSortKey, setMobileSortKey] = useState('id');

  const handleFilterChange = (col, val) => {
    setFilters(prev => ({ ...prev, [col]: val.toLowerCase() }));
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearch(e.target.value.toLowerCase());
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig?.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const processedData = useMemo(() => {
    let data = initialData.map(item => ({
      ...item,
      biomasa: (item.piezas * item.pesoKs) / 1000,
    }));

    if (globalSearch) {
      data = data.filter(item =>
        Object.values(item).some(val => String(val).toLowerCase().includes(globalSearch))
      );
    }

    data = data.filter(item =>
      Object.keys(filters).every(key =>
        String(item[key]).toLowerCase().includes(filters[key])
      )
    );

    return data;
  }, [filters, globalSearch]);

  const effectiveSortConfig = useMemo(() => {
    if (sortConfig) return sortConfig;
    if (mobileSortKey) return { key: mobileSortKey, direction: 'asc' };
    return null;
  }, [sortConfig, mobileSortKey]);

const sortedData = useMemo(() => {
  const dataToSort = [...processedData];

  const sortKey = sortConfig?.key || 'id';
  const direction = sortConfig?.direction || 'asc';

  dataToSort.sort((a, b) => {
    const aVal = a[sortKey];
    const bVal = b[sortKey];

    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  });

  return dataToSort;
}, [processedData, sortConfig]);

  const totals = useMemo(() => sortedData.reduce(
    (acc, curr) => ({
      piezas: acc.piezas + Number(curr.piezas),
      biomasa: acc.biomasa + curr.biomasa,
    }),
    { piezas: 0, biomasa: 0 }
  ), [sortedData]);

  useEffect(() => {
    setExpandedRow(null);
  }, [globalSearch, filters, sortConfig, mobileSortKey]);

  const columns = [
    { key: 'bloque', label: 'Bloque' },
    { key: 'barco', label: 'Barco' },
    { key: 'lance', label: 'Lance' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'id', label: 'ID Transacción' },
    { key: 'piezas', label: 'Piezas' },
    { key: 'pesoKs', label: 'Peso (kg)' },
    { key: 'biomasa', label: 'Biomasa (T)' },
    { key: 'corral', label: 'Corral' },
  ];

  const toggleRow = (rowKey) => {
    setExpandedRow(prev => (prev === rowKey ? null : rowKey));
  };


  return (
    <div className="dashboard-wrapper">
      <header className="dashboard-header">
        <div className="title-section">
          <h1>TABLA MAESTRA <span className="highlight">LANCES</span></h1>
          <p className="subtitle">Control de Biomasa y Captura Operativa</p>
        </div>

        <div className="summary-cards">
          <div className="card">
            <div className="card-label">Total Piezas</div>
            <div className="card-value">{totals.piezas.toLocaleString('hr-HR')}</div>
          </div>
          <div className="card highlight-card">
            <div className="card-label">Total Biomasa (T)</div>
            <div className="card-value">
              {totals.biomasa.toLocaleString('hr-HR', { minimumFractionDigits: 2 })}
            </div>
          </div>
        </div>
      </header>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search globally"
          value={globalSearch}
          onChange={handleGlobalSearch}
          className="global-search"
        />
      </div>


      <div className="table-wrapper">
        {sortedData.length === 0 ? (
          <div className="empty-state">
            <p>Nema rezultata</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                {columns.map(col => (
                  <th key={col.key}>
                    <div onClick={() => handleSort(col.key)} className="sort-label">
                      {col.label} {sortConfig?.key === col.key ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                    </div>
                    <input
                      type="text"
                      className="filter-input"
                      placeholder="Filter"
                      onChange={e => handleFilterChange(col.key, e.target.value)}
                    />
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {sortedData.map((row, i) => {
                const rowKey = row.id ?? i;
                const isOpen = expandedRow === rowKey;

                return (
                  <React.Fragment key={rowKey}>
                    <tr className="row-item desktop-row">
                      <td data-label="Bloque"><span className="badge-bloque">{row.bloque}</span></td>
                      <td data-label="Barco" className="text-bold">{row.barco}</td>
                      <td data-label="Lance"><span className="badge-lance">{row.lance}</span></td>
                      <td data-label="Empresa"><span className="badge-empresa">{row.empresa}</span></td>
                      <td data-label="ID Transacción" className="text-id">{row.id}</td>
                      <td data-label="Piezas" className="text-bold">{Number(row.piezas).toLocaleString('hr-HR')}</td>
                      <td data-label="Peso (kg)">{row.pesoKs} kg</td>
                      <td data-label="Biomasa (T)" className="text-biomasa">
                        {row.biomasa.toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                      <td data-label="Corral"><span className="badge-corral">{row.corral}</span></td>
                    </tr>

                    <tr className="mobile-row-id">
                        <button
                          type="button"
                          className="mobile-id-button"
                          onClick={() => toggleRow(rowKey)}
                          aria-expanded={isOpen}
                        >
                          <span className="mobile-id-label">ID Transacción</span>
                          <span className="mobile-id-value">{row.id}</span>
                          <span className="mobile-id-chevron">{isOpen ? '▲' : '▼'}</span>
                        </button>
                    </tr>
                    {isOpen && (
                    <tr className={`mobile-row-details ${isOpen ? 'open' : ''}`}>
                      <td className="mobile-only-cell" colSpan={columns.length}>
                        <div className="mobile-details">
                          <div className="mobile-detail"><span>Bloque</span><strong>{row.bloque}</strong></div>
                          <div className="mobile-detail"><span>Barco</span><strong>{row.barco}</strong></div>
                          <div className="mobile-detail"><span>Lance</span><strong>{row.lance}</strong></div>
                          <div className="mobile-detail"><span>Empresa</span><strong>{row.empresa}</strong></div>
                          <div className="mobile-detail"><span>Piezas</span><strong>{Number(row.piezas).toLocaleString('hr-HR')}</strong></div>
                          <div className="mobile-detail"><span>Peso (kg)</span><strong>{row.pesoKs} kg</strong></div>
                          <div className="mobile-detail"><span>Biomasa (T)</span><strong>{row.biomasa.toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
                          <div className="mobile-detail"><span>Corral</span><strong>{row.corral}</strong></div>
                        </div>
                      </td>
                    </tr>
              )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Table;
